import React from 'react';
import DocumentMeta from 'react-document-meta';
import uniqid from 'uniqid';
import _ from 'lodash';
import scrollToElement from 'scroll-to-element';
import Fuse from 'fuse.js';
import ApiHelper from '../../../shared/ApiHelper';
import { getUserID, saveUserID } from '../../../shared/StorageHelper';

export default class Help extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			title: 'Help | Irregular Area Calculator | Calculate Irregular Shape Area',
			description:
				'Find out what you can do with our irregular area calculator software. Our program easily calculates the area to any irregular shape.',
			list: [],
			inputValue: '',
			isFocus: false,
			helpedArticle: null,
			listForSearch: [],
			filteredList: [],
			userRequestData: {
				savedTopic: '',
				savedText: ''
			},
			savedUserRequests: [],
			userIdentity: null
		};

		this.inputRef = null;
	}

	componentWillMount() {
		ApiHelper.help().then(response => {
			if (response.data.success) {
				const list = response.data.posts.map(post => {
					let expand = false;

					if (this.props.location.hash) {
						if (this.props.location.hash.substring(1) === post.slug) {
							expand = true;
						}
					}

					return {
						title: post.title,
						content: post.content,
						slug: post.slug,
						expand: expand
					};
				});
				const helpedArticle = list.find(({ title }) => title === 'Can\'t find an answer. How can I get support?');
				const listForSearch = list.filter(({ title }) => title !== helpedArticle.title);
				this.setState({
					list,
					helpedArticle,
					listForSearch
				});
			}
		});
		let userIdentity = getUserID();
		if (!userIdentity) {
			userIdentity = uniqid();
			saveUserID(userIdentity);
		}
		this.setState({ userIdentity });
	}

	goToQuestion = (event) => {
		let href = event.target.getAttribute('href');

		if (href.indexOf('#') === 0) {
			const index = this.state.list.findIndex(item => item.slug === href.substring(1));

			if (index !== -1 && !this.state.list[index].expand) {
				this.toggleExpand(index);
			}
		}
	}

	saveUserRequest = _.debounce(() => {
		const { userRequestData: { savedTopic, savedText }, savedUserRequests, userIdentity } = this.state;
		const isAlreadySent = savedUserRequests.find(item => item.savedTopic === savedTopic && item.savedText === savedText);
		if (!isAlreadySent && savedText) {
			ApiHelper.saveSearchText({ text: savedText, selected_topic: savedTopic, userIdentity });
			this.setState({
				savedUserRequests: [...savedUserRequests, { savedTopic, savedText }]
			});
		}
		this.setState({
			userRequestData: {
				savedTopic: '',
				savedText: ''
			}
		});
	}, 1000);

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.list.length && this.state.list.length) {
			Array.from(document.querySelectorAll('.answer a')).forEach(el => {
				el.addEventListener('click', this.goToQuestion);
			});

			if (this.props.location.hash) {
				scrollToElement(this.props.location.hash);
			}
		}

		// If isFocus becomes false, blur the input after a short delay
		if (prevState.isFocus && !this.state.isFocus) {
			setTimeout(() => {
				if (this.inputRef) { // Use this.inputRef directly
					this.inputRef.blur();
				}
			}, 150);
		}
	}

	toggleExpand(index) {
		this.setState({
			list: this.state.list.map((item, i) =>
				i === index ? { ...item, expand: !item.expand } : item
			)
		}); // Accept an optional callback
	}

	// Modified toggleExpand to accept an optional callback
	toggleExpand(index, callback) {
		this.setState(prevState => ({
			list: prevState.list.map((item, i) => i === index ? { ...item, expand: !item.expand } : item)
		}), callback);
	}
	onChange = (event) => {
		const inputValue = event.target.value;
		this.setState({ inputValue });
		const options = {
			includeScore: true,
			threshold: 0.32,
			distance: 320,
			keys: ['title', 'content']
		};
		const fuse = new Fuse(this.state.listForSearch, options);
		const result = fuse.search(inputValue);
		this.setState({ filteredList: result.map(({ item }) => item) });
	}

	onFocus = () => {
		this.setState({ isFocus: true });
	}

	onBlur = () => {
		const { userRequestData, inputValue } = this.state;

		this.setState({
			userRequestData: {
				...userRequestData,
				savedText: inputValue
			}
		});
		this.saveUserRequest();
		// The original setTimeout in onBlur was to control dropdown visibility, not input blur.
		// We handle actual input blurring via a ref in componentDidUpdate when isFocus changes.
		this.setState({ isFocus: false }); //
	}

	clearInput = () => {
		this.setState({ inputValue: '' });
		// UPDATED: Use ref to clear input value //
		if (this.inputRef) { // Use this.inputRef directly
			this.inputRef.value = '';
		}
		this.setState({ filteredList: [] }); // Clear filtered results //
	}

	onSelect = (selectedItem, isHelped) => {
		const { list, inputValue } = this.state;
		console.log("Selected", selectedItem.title);
		this.setState({
			userRequestData: {
				savedTopic: selectedItem.title,
				savedText: inputValue
			}
		});
		this.saveUserRequest();
		if (isHelped) {
			if (this.inputRef) { // Use this.inputRef directly
				this.inputRef.value = selectedItem.title;
			}
			this.setState({ inputValue: selectedItem.title, filteredList: [] });
		}
		const elementToScrollTo = document.getElementById(selectedItem.slug); // Target li by slug
		const index = list.findIndex(item => item.title === selectedItem.title);

		if (index !== -1) {
			const itemInList = list[index];
			const scrollAction = () => {
				if (elementToScrollTo) {
					elementToScrollTo.scrollIntoView({ behavior: 'smooth' });
				} else {
					console.warn(`Element with id '${selectedItem.slug}' not found for scrolling.`);
				}
			};

			if (!itemInList.expand) {
				this.toggleExpand(index, () => {
					// Scroll after state update and re-render
					setTimeout(scrollAction, 50); // Small delay for paint
				});
			} else {
				// Already expanded, just scroll
				scrollAction();
			}
		}
	}

	render() {
		const { list, title, description, inputValue, isFocus, helpedArticle, filteredList } = this.state;

		return (
			<section className='help'>
				{list.length > 0 && (
					<article className='faq'>
						{title && <h2 className='text-center'>Help</h2>}

						<div className='input-wrapper'>
							<div className="btn input-icon left icon-search_map" />
							<input
								ref={(el) => this.inputRef = el}
								className='input'
								type="text"
								value={inputValue}
								onChange={this.onChange}
								onFocus={this.onFocus}
								onBlur={this.onBlur}
								style={{ border: `1px solid ${isFocus ? '#2196F3' : '#cccccc'}` }}
								placeholder="Search..."
							/>

							{isFocus && inputValue.trim() && filteredList.length > 0 && (
								<div className='list-options-wrapper'> 
									{filteredList.map((val, i) => (
										<div
											key={i}
											className='list-options-item' 
											onMouseDown={() => this.onSelect(val, false)}
										>
											{val.title}
										</div>
									))}
								</div>
							)}

							{!!(isFocus && inputValue.trim() && !filteredList.length) &&
								<div className='list-options-wrapper'>
									<div
										className='list-options-item'
										onMouseDown={() => this.onSelect(helpedArticle, true)}
									>
										{helpedArticle.title}
									</div>
								</div>
							}
							{inputValue && <i className="icon input-icon right icon-close_icn" onClick={this.clearInput} />}
						</div>
						<ul>
							{list.map((post, index) => {
								const classNames = ['question'];

								if (post.expand) {
									classNames.push('expand');
								}

								return (
									<li key={index} id={post.slug} className={classNames.join(' ')}>
										<p
											id={post.title}
											className='title'
											onClick={() => {
												this.toggleExpand(index);
											}}>
											{post.title}
										</p>
										<div
											className='answer'
											dangerouslySetInnerHTML={{
												__html: post.content
											}}
										/>
									</li>
								);
							})}
						</ul>
					</article>
				)}
				{title && <DocumentMeta title={title} description={description} />}
			</section>
		);
	}
}